import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getAuthToken } from './authToken';

const auth = () => ({ Authorization: 'Bearer ' + getAuthToken() });

// Alerty Agenta e-mail (np. klient anulowal zamowienie, a paczka ma juz etykiete). Znika po zakonczeniu e-maila albo "Ukryj".
export default function EmailAgentAlert({ currentUser, onOpenEmail }: { currentUser: any; onOpenEmail: (threadId: string) => void }) {
  const [items, setItems] = useState<any[]>([]);
  const mods: string[] = (currentUser && currentUser.modules) || [];
  const allowed = !!currentUser && (currentUser.role === 'admin' || mods.includes('messages') || mods.includes('email-agent'));
  const load = () => {
    axios.get('/api/email-agent/alerts', { headers: auth() })
      .then((r: any) => setItems((r.data && r.data.alerts) || []))
      .catch(() => setItems([]));
  };
  useEffect(() => {
    if (!allowed) return;
    load();
    const t = window.setInterval(load, 2 * 60 * 1000);
    return () => window.clearInterval(t);
  }, [allowed]);
  if (!allowed || items.length === 0) return null;
  const dismiss = (id: number) => {
    setItems(items.filter((x: any) => x.id !== id));
    axios.post('/api/email-agent/alerts/' + id + '/dismiss', {}, { headers: auth() }).catch(() => {});
  };
  return (
    <div style={{ background: '#fef2f2', borderBottom: '2px solid #dc2626', padding: '6px 14px', fontSize: 13, fontFamily: 'system-ui, sans-serif' }}>
      {items.map((x: any) => (
        <div key={x.id} style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', padding: '2px 0' }}>
          <b style={{ color: '#b91c1c' }}>⚠ Agent e-mail: {x.text}</b>
          {x.order_ref ? <span style={{ fontFamily: 'monospace', color: '#374151' }}>{x.order_ref}</span> : null}
          <span style={{ color: '#6b7280', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 360 }}>{x.subject}</span>
          {x.thread_id ? <button onClick={() => { onOpenEmail(x.thread_id); window.setTimeout(() => window.dispatchEvent(new Event('email-open-thread')), 50); }} style={{ padding: '2px 10px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', fontSize: 12, cursor: 'pointer' }}>Otwórz e-mail</button> : null}
          <button onClick={() => dismiss(x.id)} style={{ padding: '2px 10px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', fontSize: 12, cursor: 'pointer' }}>Ukryj</button>
        </div>
      ))}
    </div>
  );
}
